import { entries, keys, values } from '../../utils/javascript'

const regionList = [
  {
    label: 'Central Region',
    value: 'CENTRAL_REGION',
    latitude: null,
    longitude: null,
  },
  {
    label: 'North Region',
    value: 'NORTH_REGION',
    latitude: null,
    longitude: null,
  },
  {
    label: 'South Region',
    value: 'SOUTH_REGION',
    latitude: null,
    longitude: null,
  },
  {
    label: 'West Region',
    value: 'WEST_REGION',
    latitude: null,
    longitude: null,
  },
]
const countryData = {
  in: {
    // 'Andhra Pradesh': {
    //   Visakhapatnam: [],
    //   Vijayawada: [],
    //   Guntur: [],
    //   Nellore: [],
    //   Kakinada: [],
    //   Rajahmundry: [],
    //   Tirupati: [],
    //   Kadapa: [],
    //   Kurnool: [],
    //   Eluru: [],
    //   Anantapur: [],
    // },
    Karnataka: {
      Bangalore: [560001, 560002, 560003],
      Belgaum: [590001, 590002, 590003],
      Ramanagara: [562159],
      Bidadi: [562109],
    },
    Telangana: {
      Hyderabad: [500001, 500002, 500003],
      Adilabad: [504001, 504002, 504003],
      // Warangal: [],
      // Nizamabad: [],
      // Khammam: [],
      // Karimnagar: [],
      // Ramagundam: [],
      // Secunderabad: [],
      // Mahbubnagar: [],
      // Suryapet: [],
      // Miryalaguda: [],
    },
    Delhi: {
      'New Delhi': [110001, 110002, 110003, 110020],
    },
    Maharashtra: {
      Mumbai: [400001, 400002, 400003],
      Pune: [410301, 410302, 410303],
      // Nagpur: [],
      // Thane: [],
    },
    Gujarat: {
      Ahmedabad: [380001, 380002, 380003],
      Surat: [392150, 392151, 392153],
    },
    'Uttar Pradesh': {
      Noida: [201305],
    },
    Punjab: {
      Ludhiana: [141010],
      // Amritsar: [],
      // Jalandhar: [],
      // Patiala: [],
      // Bathinda: [],
    },
    Haryana: {
      Gurugram: [122002],
      // Faridabad: [],
      // Gurgaon: [],
      // Rohtak: [],
      // Hisar: [],
      // Panipat: [],
      // Karnal: [],
      // Sonipat: [],
      // Yamunanagar: [],
      // Panchkula: [],
      // Bhiwani: [],
      // Ambala: [],
      // Sirsa: [],
    },
  },
  us: {
    Michigan: {
      'Grand Rapids': [49504, 49505, 49506],
      'Ann Arbor': [48103, 48104, 48105],
    },
    'New York': {
      'Long Island City': [11101, 11102, 11103],
      'West Queens': [11368, 11369, 11370],
      'New York': [10004, 10013, 10038, 10042],
    },
    Minnesota: {
      Eagan: [55121, 55122, 55123],
      Minneapolis: [55401, 55402, 55403],
    },
    Washington: {
      Bellevue: [98007, 98008, 98009],
      Auburn: [98001, 98002],
    },
    Texas: {
      Waller: [19001],
    },
    Florida: {
      Miami: [33132],
    },
  },
  ae: {
    Dubai: {
      Dubai: ['00000'],
    },
  },
}

// const countryLabels = {
//   us: 'United States',
//   in: 'India',
//   ae: 'United Arab Emirates',
// }
const countryLabels = {
  af: 'Afghanistan',
  al: 'Albania',
  dz: 'Algeria',
  ad: 'Andorra',
  ao: 'Angola',
  ag: 'Antigua and Barbuda',
  ar: 'Argentina',
  am: 'Armenia',
  au: 'Australia',
  at: 'Austria',
  az: 'Azerbaijan',
  bs: 'Bahamas',
  bh: 'Bahrain',
  bd: 'Bangladesh',
  bb: 'Barbados',
  by: 'Belarus',
  be: 'Belgium',
  bz: 'Belize',
  bj: 'Benin',
  bt: 'Bhutan',
  bo: 'Bolivia',
  ba: 'Bosnia and Herzegovina',
  bw: 'Botswana',
  br: 'Brazil',
  bn: 'Brunei',
  bg: 'Bulgaria',
  bf: 'Burkina Faso',
  bi: 'Burundi',
  cv: 'Cabo Verde',
  kh: 'Cambodia',
  cm: 'Cameroon',
  ca: 'Canada',
  cf: 'Central African Republic',
  td: 'Chad',
  cl: 'Chile',
  cn: 'China',
  co: 'Colombia',
  km: 'Comoros',
  cg: 'Congo (Congo-Brazzaville)',
  cd: 'Congo (Democratic Republic)',
  cr: 'Costa Rica',
  hr: 'Croatia',
  cu: 'Cuba',
  cy: 'Cyprus',
  cz: 'Czechia',
  dk: 'Denmark',
  dj: 'Djibouti',
  dm: 'Dominica',
  do: 'Dominican Republic',
  ec: 'Ecuador',
  eg: 'Egypt',
  sv: 'El Salvador',
  gq: 'Equatorial Guinea',
  er: 'Eritrea',
  ee: 'Estonia',
  sz: 'Eswatini',
  et: 'Ethiopia',
  fj: 'Fiji',
  fi: 'Finland',
  fr: 'France',
  ga: 'Gabon',
  gm: 'Gambia',
  ge: 'Georgia',
  de: 'Germany',
  gh: 'Ghana',
  gr: 'Greece',
  gd: 'Grenada',
  gt: 'Guatemala',
  gn: 'Guinea',
  gw: 'Guinea-Bissau',
  gy: 'Guyana',
  ht: 'Haiti',
  hn: 'Honduras',
  hu: 'Hungary',
  is: 'Iceland',
  in: 'India',
  id: 'Indonesia',
  ir: 'Iran',
  iq: 'Iraq',
  ie: 'Ireland',
  il: 'Israel',
  it: 'Italy',
  jm: 'Jamaica',
  jp: 'Japan',
  jo: 'Jordan',
  kz: 'Kazakhstan',
  ke: 'Kenya',
  ki: 'Kiribati',
  kp: 'Korea (North)',
  kr: 'Korea (South)',
  kw: 'Kuwait',
  kg: 'Kyrgyzstan',
  la: 'Laos',
  lv: 'Latvia',
  lb: 'Lebanon',
  ls: 'Lesotho',
  lr: 'Liberia',
  ly: 'Libya',
  li: 'Liechtenstein',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  mg: 'Madagascar',
  mw: 'Malawi',
  my: 'Malaysia',
  mv: 'Maldives',
  ml: 'Mali',
  mt: 'Malta',
  mh: 'Marshall Islands',
  mr: 'Mauritania',
  mu: 'Mauritius',
  mx: 'Mexico',
  fm: 'Micronesia',
  md: 'Moldova',
  mc: 'Monaco',
  mn: 'Mongolia',
  me: 'Montenegro',
  ma: 'Morocco',
  mz: 'Mozambique',
  mm: 'Myanmar (Burma)',
  na: 'Namibia',
  nr: 'Nauru',
  np: 'Nepal',
  nl: 'Netherlands',
  nz: 'New Zealand',
  ni: 'Nicaragua',
  ne: 'Niger',
  ng: 'Nigeria',
  mk: 'North Macedonia',
  no: 'Norway',
  om: 'Oman',
  pk: 'Pakistan',
  pw: 'Palau',
  ps: 'Palestine State',
  pa: 'Panama',
  pg: 'Papua New Guinea',
  py: 'Paraguay',
  pe: 'Peru',
  ph: 'Philippines',
  pl: 'Poland',
  pt: 'Portugal',
  qa: 'Qatar',
  ro: 'Romania',
  ru: 'Russia',
  rw: 'Rwanda',
  kn: 'Saint Kitts and Nevis',
  lc: 'Saint Lucia',
  vc: 'Saint Vincent and the Grenadines',
  ws: 'Samoa',
  sm: 'San Marino',
  st: 'Sao Tome and Principe',
  sa: 'Saudi Arabia',
  sn: 'Senegal',
  rs: 'Serbia',
  sc: 'Seychelles',
  sl: 'Sierra Leone',
  sg: 'Singapore',
  sk: 'Slovakia',
  si: 'Slovenia',
  sb: 'Solomon Islands',
  so: 'Somalia',
  za: 'South Africa',
  ss: 'South Sudan',
  es: 'Spain',
  lk: 'Sri Lanka',
  sd: 'Sudan',
  sr: 'Suriname',
  se: 'Sweden',
  ch: 'Switzerland',
  sy: 'Syria',
  tj: 'Tajikistan',
  tz: 'Tanzania',
  th: 'Thailand',
  tl: 'Timor-Leste',
  tg: 'Togo',
  to: 'Tonga',
  tt: 'Trinidad and Tobago',
  tn: 'Tunisia',
  tr: 'Turkey',
  tm: 'Turkmenistan',
  tv: 'Tuvalu',
  ug: 'Uganda',
  ua: 'Ukraine',
  ae: 'United Arab Emirates',
  gb: 'United Kingdom',
  us: 'United States of America',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  vu: 'Vanuatu',
  va: 'Vatican City',
  ve: 'Venezuela',
  vn: 'Vietnam',
  ye: 'Yemen',
  zm: 'Zambia',
  zw: 'Zimbabwe',
}

const countryOptions = entries(countryLabels).map(([key, value]) => ({
  value: key,
  label: value,
}))

const stateOptions = values(countryData)
  .map(value => keys(value).map(state => ({ value: state, label: state })))
  .flat()

const cityOptions = values(countryData)
  .map(countryObj =>
    values(countryObj).map(stateObj =>
      keys(stateObj).map(city => ({ value: city, label: city })),
    ),
  )
  .flat(2)

const pincodeOptions = values(countryData)
  .map(countryObj =>
    values(countryObj).map(stateObj =>
      values(stateObj).map(pinArr =>
        pinArr?.map(pin => ({ value: pin, label: pin })),
      ),
    ),
  )
  .flat(3)

const countryEnumOption = [
  { label: 'Afghanistan', value: 'AFGHANISTAN' },
  { label: 'Albania', value: 'ALBANIA' },
  { label: 'Algeria', value: 'ALGERIA' },
  { label: 'Andorra', value: 'ANDORRA' },
  { label: 'Angola', value: 'ANGOLA' },
  { label: 'Antigua And Barbuda', value: 'ANTIGUA_AND_BARBUDA' },
  { label: 'Argentina', value: 'ARGENTINA' },
  { label: 'Armenia', value: 'ARMENIA' },
  { label: 'Australia', value: 'AUSTRALIA' },
  { label: 'Austria', value: 'AUSTRIA' },
  { label: 'Azerbaijan', value: 'AZERBAIJAN' },
  { label: 'Bahamas', value: 'BAHAMAS' },
  { label: 'Bahrain', value: 'BAHRAIN' },
  { label: 'Bangladesh', value: 'BANGLADESH' },
  { label: 'Barbados', value: 'BARBADOS' },
  { label: 'Belarus', value: 'BELARUS' },
  { label: 'Belgium', value: 'BELGIUM' },
  { label: 'Belize', value: 'BELIZE' },
  { label: 'Benin', value: 'BENIN' },
  { label: 'Bhutan', value: 'BHUTAN' },
  { label: 'Bolivia', value: 'BOLIVIA' },
  { label: 'Bosnia And Herzegovina', value: 'BOSNIA_AND_HERZEGOVINA' },
  { label: 'Botswana', value: 'BOTSWANA' },
  { label: 'Brazil', value: 'BRAZIL' },
  { label: 'Brunei', value: 'BRUNEI' },
  { label: 'Bulgaria', value: 'BULGARIA' },
  { label: 'Burkina Faso', value: 'BURKINA_FASO' },
  { label: 'Burundi', value: 'BURUNDI' },
  { label: 'Cabo Verde', value: 'CABO_VERDE' },
  { label: 'Cambodia', value: 'CAMBODIA' },
  { label: 'Cameroon', value: 'CAMEROON' },
  { label: 'Canada', value: 'CANADA' },
  { label: 'Central African Republic', value: 'CENTRAL_AFRICAN_REPUBLIC' },
  { label: 'Chad', value: 'CHAD' },
  { label: 'Chile', value: 'CHILE' },
  { label: 'China', value: 'CHINA' },
  { label: 'Colombia', value: 'COLOMBIA' },
  { label: 'Comoros', value: 'COMOROS' },
  { label: 'Congo', value: 'CONGO' },
  { label: 'Costa Rica', value: 'COSTA_RICA' },
  { label: 'Croatia', value: 'CROATIA' },
  { label: 'Cuba', value: 'CUBA' },
  { label: 'Cyprus', value: 'CYPRUS' },
  { label: 'Czechia', value: 'CZECHIA' },
  {
    label: 'Democratic Republic Of The Congo',
    value: 'DEMOCRATIC_REPUBLIC_OF_THE_CONGO',
  },
  { label: 'Denmark', value: 'DENMARK' },
  { label: 'Djibouti', value: 'DJIBOUTI' },
  { label: 'Dominica', value: 'DOMINICA' },
  { label: 'Dominican Republic', value: 'DOMINICAN_REPUBLIC' },
  { label: 'Ecuador', value: 'ECUADOR' },
  { label: 'Egypt', value: 'EGYPT' },
  { label: 'El Salvador', value: 'EL_SALVADOR' },
  { label: 'Equatorial Guinea', value: 'EQUATORIAL_GUINEA' },
  { label: 'Eritrea', value: 'ERITREA' },
  { label: 'Estonia', value: 'ESTONIA' },
  { label: 'Eswatini', value: 'ESWATINI' },
  { label: 'Ethiopia', value: 'ETHIOPIA' },
  { label: 'Fiji', value: 'FIJI' },
  { label: 'Finland', value: 'FINLAND' },
  { label: 'France', value: 'FRANCE' },
  { label: 'Gabon', value: 'GABON' },
  { label: 'Gambia', value: 'GAMBIA' },
  { label: 'Georgia', value: 'GEORGIA' },
  { label: 'Germany', value: 'GERMANY' },
  { label: 'Ghana', value: 'GHANA' },
  { label: 'Greece', value: 'GREECE' },
  { label: 'Grenada', value: 'GRENADA' },
  { label: 'Guatemala', value: 'GUATEMALA' },
  { label: 'Guinea', value: 'GUINEA' },
  { label: 'Guinea Bissau', value: 'GUINEA_BISSAU' },
  { label: 'Guyana', value: 'GUYANA' },
  { label: 'Haiti', value: 'HAITI' },
  { label: 'Holy See', value: 'HOLY_SEE' },
  { label: 'Honduras', value: 'HONDURAS' },
  { label: 'Hungary', value: 'HUNGARY' },
  { label: 'Iceland', value: 'ICELAND' },
  { label: 'India', value: 'INDIA' },
  { label: 'Indonesia', value: 'INDONESIA' },
  { label: 'Iran', value: 'IRAN' },
  { label: 'Iraq', value: 'IRAQ' },
  { label: 'Ireland', value: 'IRELAND' },
  { label: 'Israel', value: 'ISRAEL' },
  { label: 'Italy', value: 'ITALY' },
  { label: 'Jamaica', value: 'JAMAICA' },
  { label: 'Japan', value: 'JAPAN' },
  { label: 'Jordan', value: 'JORDAN' },
  { label: 'Kazakhstan', value: 'KAZAKHSTAN' },
  { label: 'Kenya', value: 'KENYA' },
  { label: 'Kiribati', value: 'KIRIBATI' },
  { label: 'Kuwait', value: 'KUWAIT' },
  { label: 'Kyrgyzstan', value: 'KYRGYZSTAN' },
  { label: 'Laos', value: 'LAOS' },
  { label: 'Latvia', value: 'LATVIA' },
  { label: 'Lebanon', value: 'LEBANON' },
  { label: 'Lesotho', value: 'LESOTHO' },
  { label: 'Liberia', value: 'LIBERIA' },
  { label: 'Libya', value: 'LIBYA' },
  { label: 'Liechtenstein', value: 'LIECHTENSTEIN' },
  { label: 'Lithuania', value: 'LITHUANIA' },
  { label: 'Luxembourg', value: 'LUXEMBOURG' },
  { label: 'Madagascar', value: 'MADAGASCAR' },
  { label: 'Malawi', value: 'MALAWI' },
  { label: 'Malaysia', value: 'MALAYSIA' },
  { label: 'Maldives', value: 'MALDIVES' },
  { label: 'Mali', value: 'MALI' },
  { label: 'Malta', value: 'MALTA' },
  { label: 'Marshall Islands', value: 'MARSHALL_ISLANDS' },
  { label: 'Mauritania', value: 'MAURITANIA' },
  { label: 'Mauritius', value: 'MAURITIUS' },
  { label: 'Mexico', value: 'MEXICO' },
  { label: 'Micronesia', value: 'MICRONESIA' },
  { label: 'Moldova', value: 'MOLDOVA' },
  { label: 'Monaco', value: 'MONACO' },
  { label: 'Mongolia', value: 'MONGOLIA' },
  { label: 'Montenegro', value: 'MONTENEGRO' },
  { label: 'Morocco', value: 'MOROCCO' },
  { label: 'Mozambique', value: 'MOZAMBIQUE' },
  { label: 'Myanmar', value: 'MYANMAR' },
  { label: 'Namibia', value: 'NAMIBIA' },
  { label: 'Nauru', value: 'NAURU' },
  { label: 'Nepal', value: 'NEPAL' },
  { label: 'Netherlands', value: 'NETHERLANDS' },
  { label: 'New Zealand', value: 'NEW_ZEALAND' },
  { label: 'Nicaragua', value: 'NICARAGUA' },
  { label: 'Niger', value: 'NIGER' },
  { label: 'Nigeria', value: 'NIGERIA' },
  { label: 'North Korea', value: 'NORTH_KOREA' },
  { label: 'North Macedonia', value: 'NORTH_MACEDONIA' },
  { label: 'Norway', value: 'NORWAY' },
  { label: 'Oman', value: 'OMAN' },
  { label: 'Pakistan', value: 'PAKISTAN' },
  { label: 'Palau', value: 'PALAU' },
  { label: 'Palestine', value: 'PALESTINE' },
  { label: 'Panama', value: 'PANAMA' },
  { label: 'Papua New Guinea', value: 'PAPUA_NEW_GUINEA' },
  { label: 'Paraguay', value: 'PARAGUAY' },
  { label: 'Peru', value: 'PERU' },
  { label: 'Philippines', value: 'PHILIPPINES' },
  { label: 'Poland', value: 'POLAND' },
  { label: 'Portugal', value: 'PORTUGAL' },
  { label: 'Qatar', value: 'QATAR' },
  { label: 'Romania', value: 'ROMANIA' },
  { label: 'Russia', value: 'RUSSIA' },
  { label: 'Rwanda', value: 'RWANDA' },
  { label: 'Saint Kitts And Nevis', value: 'SAINT_KITTS_AND_NEVIS' },
  { label: 'Saint Lucia', value: 'SAINT_LUCIA' },
  {
    label: 'Saint Vincent And The Grenadines',
    value: 'SAINT_VINCENT_AND_THE_GRENADINES',
  },
  { label: 'Samoa', value: 'SAMOA' },
  { label: 'San Marino', value: 'SAN_MARINO' },
  { label: 'Sao Tome And Principe', value: 'SAO_TOME_AND_PRINCIPE' },
  { label: 'Saudi Arabia', value: 'SAUDI_ARABIA' },
  { label: 'Senegal', value: 'SENEGAL' },
  { label: 'Serbia', value: 'SERBIA' },
  { label: 'Seychelles', value: 'SEYCHELLES' },
  { label: 'Sierra Leone', value: 'SIERRA_LEONE' },
  { label: 'Singapore', value: 'SINGAPORE' },
  { label: 'Slovakia', value: 'SLOVAKIA' },
  { label: 'Slovenia', value: 'SLOVENIA' },
  { label: 'Solomon Islands', value: 'SOLOMON_ISLANDS' },
  { label: 'Somalia', value: 'SOMALIA' },
  { label: 'South Africa', value: 'SOUTH_AFRICA' },
  { label: 'South Korea', value: 'SOUTH_KOREA' },
  { label: 'South Sudan', value: 'SOUTH_SUDAN' },
  { label: 'Spain', value: 'SPAIN' },
  { label: 'Sri Lanka', value: 'SRI_LANKA' },
  { label: 'Sudan', value: 'SUDAN' },
  { label: 'Suriname', value: 'SURINAME' },
  { label: 'Sweden', value: 'SWEDEN' },
  { label: 'Switzerland', value: 'SWITZERLAND' },
  { label: 'Syria', value: 'SYRIA' },
  { label: 'Taiwan', value: 'TAIWAN' },
  { label: 'Tajikistan', value: 'TAJIKISTAN' },
  { label: 'Tanzania', value: 'TANZANIA' },
  { label: 'Thailand', value: 'THAILAND' },
  { label: 'Timor Leste', value: 'TIMOR_LESTE' },
  { label: 'Togo', value: 'TOGO' },
  { label: 'Tonga', value: 'TONGA' },
  { label: 'Trinidad And Tobago', value: 'TRINIDAD_AND_TOBAGO' },
  { label: 'Tunisia', value: 'TUNISIA' },
  { label: 'Turkey', value: 'TURKEY' },
  { label: 'Turkmenistan', value: 'TURKMENISTAN' },
  { label: 'Tuvalu', value: 'TUVALU' },
  { label: 'Uganda', value: 'UGANDA' },
  { label: 'Ukraine', value: 'UKRAINE' },
  { label: 'United Arab Emirates', value: 'UNITED_ARAB_EMIRATES' },
  { label: 'United Kingdom', value: 'UNITED_KINGDOM' },
  { label: 'United States Of America', value: 'UNITED_STATES_OF_AMERICA' },
  { label: 'Uruguay', value: 'URUGUAY' },
  { label: 'Uzbekistan', value: 'UZBEKISTAN' },
  { label: 'Vanuatu', value: 'VANUATU' },
  { label: 'Venezuela', value: 'VENEZUELA' },
  { label: 'Vietnam', value: 'VIETNAM' },
  { label: 'Yemen', value: 'YEMEN' },
  { label: 'Zambia', value: 'ZAMBIA' },
  { label: 'Zimbabwe', value: 'ZIMBABWE' },
]

export {
  countryData,
  cityOptions,
  countryOptions,
  pincodeOptions,
  stateOptions,
  countryLabels,
  regionList,
  countryEnumOption,
}
